import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {actionLoaderReset} from 'modules/loader/slice';
import {useEffect} from 'react';

export const useLoaderReset = (type: string) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        return () => {
            dispatch(actionLoaderReset(type));
        };
    });
};
